import { render, staticRenderFns } from "./ConversionChangeHistory.vue?vue&type=template&id=f89e1222&scoped=true&"
import script from "./ConversionChangeHistory.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ConversionChangeHistory.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ConversionChangeHistory.vue?vue&type=style&index=0&id=f89e1222&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89e1222",
  null
  
)

export default component.exports